import { useEffect } from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Gem, Clapperboard, BookOpen, Headset, HandCoins } from "lucide-react";
import { SupportProvider, useSupportUnreadCount } from "@/contexts/SupportContext";
import { Sidebar } from "./Sidebar";
import { AccountMenu } from "./AccountMenu";
export function WebLayout() {
  return (
    <SupportProvider>
      <WebLayoutInner />
    </SupportProvider>
  );
}

function WebLayoutInner() {
  const { pathname } = useLocation();
  const supportUnread = useSupportUnreadCount();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="portal-layout">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Sidebar />
      <main id="main-content" className="portal-main">
        <Outlet />
      </main>
      <nav className="portal-mobile-nav" aria-label="Mobile navigation">
        {[
          { to: "/coach", label: "My Coach", Icon: Clapperboard },
          { to: "/discover", label: "Products", Icon: Gem },
          { to: "/affiliate", label: "Earn", Icon: HandCoins },
          { to: "/help", label: "How to use", Icon: BookOpen },
          { to: "/support", label: "Support", Icon: Headset },
        ].map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} className="nav-with-badge">
            <Icon size={21} />
            <span>{label}</span>
            {to === "/support" && supportUnread > 0 && <b className="nav-badge" aria-label={`${supportUnread} unread`}>{supportUnread}</b>}
          </NavLink>
        ))}
        <AccountMenu variant="mobile" />
      </nav>
    </div>
  );
}
